import React, { createContext, useState } from 'react'

export const ThemeContext = createContext({
  isDarkTheme: false,
  toggleTheme: () => {}
})

const ThemeProvider = ({ children }) => {
  const [isDarkTheme, setIsDarkTheme] = useState(false)
  const toggleTheme = goDark => {
    if (goDark === undefined) setIsDarkTheme(!isDarkTheme)
    else {
      setIsDarkTheme(goDark)
    }
  }
  return (
    <ThemeContext.Provider value={{ isDarkTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
